<template>
    <div >
 
    </div>
</template>

<script>

export default {
    name: 'Articlelist',    
    data () {
        return {
       
        }
    },
    methods:{

    },
    created() {

    },
    mounted() {

	},
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/article/articlelist.vue